export type SrChatChartPoint = { label: string; value: number };

export type SrChatChart = {
    id: string;
    title: string;
    chart_type: "bar";
    group_by: string;
    total?: number;
    data: SrChatChartPoint[];
};

export const normalizeSrCharts = (raw: unknown): SrChatChart[] => {
    if (!Array.isArray(raw)) return [];
    return raw
        .filter((c) => c && Array.isArray((c as SrChatChart).data))
        .map((c) => c as SrChatChart);
};
